import { Component, Input, OnInit } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-sign-in-order',
	templateUrl: './sign-in-order.page.html',
	styleUrls: ['sign-in-order.page.scss'],
})
export class signUpSuccessPage extends RepositoryDirective implements OnInit {
	static url = 'sign-up-success';
	@Input() name!: string;

	constructor(public repository: RepositoryService) {
		super(repository);
	}

	ngOnInit(): void {
		super.ngOnInit();
		setTimeout(() => {
			const OrderId = localStorage.getItem('currentOrderId');
			if (this.name) {
				window.location.href =
					environment.baseUrl +
					'/v1/customer/oauth/fra-eintracht/authorize?customerGroup=' +
					environment.customerGroup +
					'&order=' +
					OrderId +
					'&name=' +
					this.name;
				return;
			}
			window.location.href =
				environment.baseUrl +
				'/v1/customer/oauth/fra-eintracht/authorize?customerGroup=' +
				environment.customerGroup +
				'&order=' +
				OrderId;
		}, 3000);
	}
}
